/**
 * Browser detection utilities
 */

export function getBrowserType() {
  if (typeof navigator === 'undefined') {
    return 'unknown';
  }

  const ua = navigator.userAgent.toLowerCase();

  // Edge (must be before Chrome check)
  if (/edg\//.test(ua)) {
    return 'edge';
  }

  // Opera (must be before Chrome check)
  if (/opr\/|opera/.test(ua)) {
    return 'opera';
  }

  // Chrome
  if (/chrome/.test(ua) && !/chromium/.test(ua)) {
    return 'chrome';
  }

  // Firefox
  if (/firefox/.test(ua)) {
    return 'firefox';
  }

  // Safari (must be after Chrome check)
  if (/safari/.test(ua) && !/chrome/.test(ua)) {
    return 'safari';
  }

  return 'unknown';
}

export function supportsBeforeInstallPrompt() {
  const browser = getBrowserType();
  return browser === 'chrome' || browser === 'edge';
}

export function supportsAddToHomeScreen() {
  // All modern browsers support "Add to Home Screen" / "Add to Home" via UI
  // even if they don't expose beforeinstallprompt event
  return typeof navigator !== 'undefined';
}

export function isIOSDevice() {
  if (typeof navigator === 'undefined') {
    return false;
  }

  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

export function getInstallInstructions(browser, isIOS = false) {
  if (isIOS) {
    return 'ios';
  }

  switch (browser) {
    case 'safari':
      return 'safari';
    case 'firefox':
      return 'firefox';
    case 'opera':
      return 'opera';
    case 'chrome':
    case 'edge':
      return 'prompt'; // These use beforeinstallprompt
    default:
      return 'generic';
  }
}
